import { render, staticRenderFns } from "./voyage.vue?vue&type=template&id=7e9a480f&"
import script from "./voyage.vue?vue&type=script&lang=js&"
export * from "./voyage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports